export type Name = string;
export enum Gender {
  Male,
  Female
}


// WEBPACK FOOTER //
// ./src/model/npc.ts